<template>
  <div class="line-items">
    <transition-group name="list" tag="div">
      <invoice-line-item
        v-for="item in items"
        :key="item.id"
        :lineItem="item"
        @removeLineItem="removeLineItem"
        class="list-item"
      />
    </transition-group>
    <div class="add-line-item">
      <button type="button" @click="$emit('addLineItem')" class="button icon-button" title="Add line item">
        <svg class="icon fill-blue-dream" id="add" width="100%" height="100%"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40"><path d="M20 0C9 0 0 9 0 20s9 20 20 20 20-9 20-20S31 0 20 0zm0 38c-9.9 0-18-8.1-18-18S10.1 2 20 2s18 8.1 18 18-8.1 18-18 18z"></path><path d="M28 20c0 .5-.5 1-1 1h-6v6.3c0 .6-.5 1-1 1s-1-.4-1-1V21h-6.3c-.6 0-1-.5-1-1s.4-1 1-1H19v-6c0-.5.5-1 1-1s1 .5 1 1v6h6c.5 0 1 .5 1 1z"></path></svg></svg>
        <span class="icon-button-link">Add line item</span>
      </button>
    </div>
  </div>
</template>

<script>
import InvoiceLineItem from './InvoiceFormLineItem.vue'

export default {
  name: 'InvoiceFormLineItems',
  components: {
    InvoiceLineItem
  },
  props: {
    items: Array
  },
  methods: {
    removeLineItem (idToRemove) {
      this.$emit('removeLineItem', idToRemove)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../styles/Variables.scss';

.line-items {
  grid-column: 1 / 3;
  .add-line-item {
    border-bottom: 1px solid $grey;
    margin-bottom: 1.875rem;
    margin-top: .9375rem;
    padding-bottom: 1.875rem;
    .icon-button {
      color: $blue-dream;
      svg {
        fill: $blue-dream;
      }
      &:hover {
        color: $la-confidential;
        svg {
          fill: $la-confidential;
        }
      }
    }
  }
}
/* Transitions */
.list-item {
  display: block;
}
.list-enter-active, .list-leave-active {
  transition: all 1s;
}
.list-enter, .list-leave-to {
  opacity: 0;
  transform: translateY(-30px);
}
</style>
